module.exports = __webpack_public_path__ + "static/media/hamburguerforno.e2b66a8b.webp";